import axios from 'axios'

if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = 'http://192.168.0.51:8083/';
    // axios.defaults.baseURL = 'http://106.14.72.73:9700/api/';
    console.log(axios.defaults.baseURL)
} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = 'api/';
}
axios.defaults.timeout = 10000;

axios.interceptors.request.use(    // 请求拦截器
    config => {
        const token = sessionStorage.getItem('token');
        if (token) {
            config.headers = {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json' //配置请求头
            }
        } else {
            config.headers = {
                'Content-Type': 'application/json' //配置请求头
            }
        }
        return config;
    },
    error => {
        return Promise.error(error);
    })

axios.interceptors.response.use(response => {
    console.log(response)
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
    var code = response.data.code || 200;
    // 否则的话抛出错误
    if (code === 401) {
        console.log('登录状态已过期')
        location.href = '/#/';
        sessionStorage.removeItem('token');
    } else if (code != 200 && code != 500) {
        return Promise.reject('error')
    } else {
        return Promise.resolve(response);
    }
},
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码    
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {
        console.log(error)
        if (error.data.code) {
            switch (error.data.code) {
                // 401: 
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。                
                case 401:
                    location.href = '/#/';
                    sessionStorage.removeItem('token');
                    break;
                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面                
                case 403:
                    location.href = '/#/';
                    sessionStorage.removeItem('token');
                    // store.commit('loginSuccess', null);
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面 
                    break;
                // 404请求不存在
                case 404:
                    // Toast({
                    //     message: '网络请求不存在',
                    //     duration: 1500,
                    //     forbidClick: true
                    // });
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    console.log(error.data.msg)
                // Toast({
                //     message:error.data.msg,
                //     duration: 1500,
                //     forbidClick: true
                // });
            }
            return Promise.reject(error.data);
        }
    }
)
export function get(url, params) {
    return new Promise((resolve, reject) => {
        console.log(url)
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            reject(err.data)
        })
    })
}

export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}


// WEBPACK FOOTER //
// ./src/api/request.js